import { createContext, useContext, useState, useEffect } from 'react';

const ActorContext = createContext();

export const ACTORS = {
  moe_hq: {
    id: 'moe_hq',
    name: 'Ministry of Education HQ',
    shortName: 'MOE HQ',
    role: 'Governing Authority',
    userName: 'Ms Lim Hui Shan',
    userRole: 'Senior Librarian, Curriculum Division',
    userEmail: 'lim_hui_shan@moe.gov.sg',
    basePath: '/moe',
    logoInitials: 'MOE',
    color: '#B0181F'
  },
  civica: {
    id: 'civica',
    name: 'Civica',
    shortName: 'Civica',
    role: 'Contractor',
    userName: 'Mr Rajesh Kumar',
    userRole: 'CDS Programme Manager',
    userEmail: 'rajesh.kumar@civica.com.sg',
    basePath: '/civica',
    logoInitials: 'CIV',
    color: '#2E5F8A'
  },
  school: {
    id: 'school',
    name: 'Orchid Primary',
    shortName: 'Orchid Primary',
    role: 'Participating School',
    userName: 'Mrs Tan Mei Ling',
    userRole: 'Library Coordinator',
    userEmail: 'tan_mei_ling@orchidpri.edu.sg',
    basePath: '/school',
    logoInitials: 'OPS',
    color: '#1E4D35'
  },
  supplier: {
    id: 'supplier',
    name: 'OpenTrolley',
    shortName: 'OpenTrolley',
    role: 'Book Supplier',
    userName: 'Mr David Lim',
    userRole: 'Account Manager',
    userEmail: 'david.lim@opentrolley.com',
    basePath: '/supplier',
    logoInitials: 'OT',
    color: '#7A4020'
  },
  mk: {
    id: 'mk',
    name: 'MK @ Bendemeer',
    shortName: 'MK Bendemeer',
    role: 'MOE Kindergarten',
    userName: 'Ms Faridah Binte Hassan',
    userRole: 'Principal',
    userEmail: 'faridah@mkbendemeer.edu.sg',
    basePath: '/mk',
    logoInitials: 'MK',
    color: '#5B3F8A'
  }
};

export const NAVIGATION = {
  moe_hq: [
    { name: 'Dashboard', path: '/moe/dashboard', icon: 'LayoutDashboard' },
    { name: 'CDS Cycle Setup', path: '/moe/cycle-setup', icon: 'Settings' },
    { name: 'Curation Approval', path: '/moe/curation-approval', icon: 'ClipboardCheck' },
    { name: 'Quote Approval', path: '/moe/quote-approval', icon: 'DollarSign' },
    { name: 'School Selections', path: '/moe/school-monitor', icon: 'School' },
    { name: 'Pilot Management', path: '/moe/pilot-management', icon: 'FlaskConical' },
    { name: 'MK Programme', path: '/moe/mk-programme', icon: 'GraduationCap' },
    { name: 'Reports & Analytics', path: '/moe/reports', icon: 'BarChart3' }
  ],
  civica: [
    { name: 'Dashboard', path: '/civica/dashboard', icon: 'LayoutDashboard' },
    { name: 'Curation Management', path: '/civica/curation', icon: 'BookOpen' },
    { name: 'Quote Invitations', path: '/civica/quote-invitations', icon: 'Send' },
    { name: 'Order Collation', path: '/civica/po-collation', icon: 'FileText' },
    { name: 'Delivery Status', path: '/civica/delivery-status', icon: 'Truck' },
    { name: 'Invoicing', path: '/civica/invoicing', icon: 'Receipt' }
  ],
  school: [
    { name: 'Dashboard', path: '/school/dashboard', icon: 'LayoutDashboard' },
    { name: 'Budget Setup', path: '/school/budget-setup', icon: 'Wallet' },
    { name: 'Title Selection', path: '/school/title-selection', icon: 'BookOpen' },
    { name: 'Pay-Per-Use', path: '/school/pay-per-use', icon: 'Package' },
    { name: 'My Orders', path: '/school/orders', icon: 'ShoppingCart' }
  ],
  supplier: [
    { name: 'Dashboard', path: '/supplier/dashboard', icon: 'LayoutDashboard' },
    { name: 'Quote Response', path: '/supplier/quote-response', icon: 'MessageSquare' },
    { name: 'PO Fulfilment', path: '/supplier/po-fulfilment', icon: 'Package' },
    { name: 'Order History', path: '/supplier/order-history', icon: 'History' }
  ],
  mk: [
    { name: 'Dashboard', path: '/mk/dashboard', icon: 'LayoutDashboard' },
    { name: 'My Book Order', path: '/mk/book-order', icon: 'BookOpen' },
    { name: 'Delivery Tracking', path: '/mk/delivery-tracking', icon: 'Truck' }
  ]
};

export function ActorProvider({ children }) {
  const [currentActor, setCurrentActor] = useState(() => {
    const saved = localStorage.getItem('currentActor');
    return saved ? JSON.parse(saved) : ACTORS.moe_hq;
  });

  useEffect(() => {
    localStorage.setItem('currentActor', JSON.stringify(currentActor));
  }, [currentActor]);

  const switchActor = (actorId) => {
    const actor = ACTORS[actorId];
    if (actor) {
      setCurrentActor(actor);
    }
  };

  const navigation = NAVIGATION[currentActor.id] || [];

  return (
    <ActorContext.Provider value={{ currentActor, switchActor, navigation, actors: ACTORS }}>
      {children}
    </ActorContext.Provider>
  );
}

export function useActor() {
  const context = useContext(ActorContext);
  if (!context) {
    throw new Error('useActor must be used within an ActorProvider');
  }
  return context;
}
